import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SearchBar from "../../components/universal/SearchBar";
import GlobalPlanForm from "./GlobalPlanForm";
import Navbar from "../../components/universal/Navbar";

function AddPlans() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // ✅ Check if the current path includes "addfield"
  const hideUI = location.pathname.includes("addfield")||location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");

  const { church } = location.state || {};
  const rowData = location.state;
  const navigate = useNavigate();

  return (
    <div className="App relative bg-[#191919] h-fit min-h-screen flex p-4">
      {/* ✅ Conditionally render Navbar */}
      {!hideUI && <Navbar />}

      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full">
          {/* ✅ Conditionally render SearchBar */}
          {!hideUI && (
            <SearchBar
              placeholder={"Search"}
              //value={value}
              //onChangeSearchBar={onChangeSearchBar}
            />
          )}

          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex justify-end">
              <Link to={"/plans/all"}>
                <button className=" text-[13px] text-greyish border px-4 py-2 border-greyish bg-blackish rounded-xl">
                  See All Plans
                </button>
              </Link>
            </div>

            <GlobalPlanForm
              rowData={rowData}
              typeofentity="church"
              onClose={() => navigate("/plans/all")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddPlans;
